/**
 * Cache is disabled
 */
export type CacheNone = {
  type: 'none'
}

/**
 * Cache values for a fixed period of time
 */
export type CacheAbsolute = {
  type: 'absolute'
  /** Expiration in seconds */
  ttl: number
}

/**
 * Allows the cache to immediately return a stale response while it revalidates it in background
 *
 *  +---------+           +-------+                +---------+
 *  | Client  |           | Cache |                | Network |
 *  +---------+           +-------+                +---------+
 *      |                    |                         |
 *      | Request            |                         |
 *      |------------------->|                         |
 *      |                    |                         |
 *      |   Response (stale) |                         |
 *      |<-------------------|                         |
 *      |                    |                         |
 *      |                    | Background request      |
 *      |                    | if `maxAge` expired     |
 *      |                    |------------------------>|
 *      |                    |                         |
 *      |                    |           Refresh cache |
 *      |                    |    (TTL = `revalidate`) |
 *      |                    |<------------------------|
 *      |                    |                         |
 */
export type CacheRevalidate = {
  type: 'revalidate'
  /** Seconds until the response is considered "stale" */
  maxAge: number
  /**
   * In seconds, the duration of the revalidation period. It indicates for how long it is
   * accepted to return a "stale" response to the user while it is refreshed in background
   */
  revalidate: number
  /**
   * Seconds a resource is locked to prevent concurrent revalidations
   * @default 5
   */
  lockRevalidation?: number
}

export type CacheOption = CacheRevalidate | CacheAbsolute | CacheNone

export const DEFAULT_CACHE: CacheOption = {
  type: 'absolute',
  ttl: 60 * 60,
}

const SWR_CACHE: CacheOption = {
  type: 'revalidate',
  maxAge: 60,
  revalidate: 60 * 60 * 24,
}

const NO_CACHE: CacheOption = {
  type: 'none',
}

export function getCacheOption(isPreview: boolean): CacheOption {
  return isPreview ? NO_CACHE : SWR_CACHE
}
